module.exports = __webpack_public_path__ + "img/c06_unitslinger_Normal_ua.68648e55.webp";